import { RouterProvider } from "react-router";

import Progress from "@components/progress/progress";

import router from "@user/router";

import PlcManager from "@user/plc/plc_manager";

function App() {
  return (
    <>
      <div className="wrap">
        <RouterProvider router={router} />
      </div>
      <Progress />
      <PlcManager />
    </>
  );
}

export default App;
